/**
 * Stimulus mixin: close on Escape key.
 * Call add() when opening, remove() when closing.
 */

/**
 * @param {object} controller - Stimulus controller instance (for binding)
 * @param {() => void} onEscape - callback when Escape is pressed
 * @returns {{ add: () => void, remove: () => void }}
 */
export function useEscapeKey(controller, onEscape) {
  const bound = onEscape.bind(controller)
  return {
    add() {
      document.addEventListener("keydown", bound)
    },
    remove() {
      document.removeEventListener("keydown", bound)
    }
  }
}
